import config from 'Config'; /* eslint-disable-line */
import store from '../../';

export default async (body) => {
  const authUser = store.getState().user;
  return fetch(`${config.apiUrl}/accesscodes`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: authUser.access_token,
      'grifin-user-key': authUser.publicKey,
    },
    body: JSON.stringify(body),
  })
    .then(async (response) => {
      if (response.status !== 200 || false) {
        const json = await response.json();
        throw new Error(json);
      }
      return response;
    })
    .then(async (response) => {
      const json = await response.json();

      return { success: true, data: json };
    })
    .catch((error) => ({ error }));
};
